import React from 'react';

import {
  CHAIN_ORDER,
  CHAIN_STAKE_CONFIG,
  ChainKey,
} from 'config/chainStakeConfig';

import {
  ChainGrid,
  ChainTile,
  Glyph,
  ChainLabel,
  ChainName,
  ChainSub,
  Check,
} from './styled';
import { PolygonGlyph, SolanaGlyph } from './ChainGlyphs';

export interface ChainSelectorProps {
  value: ChainKey;
  onChange: (chain: ChainKey) => void;
}

const GLYPH_BY_CHAIN: Record<ChainKey, React.FC<{ size?: number }>> = {
  polygon: PolygonGlyph,
  solana: SolanaGlyph,
};

const ChainSelector: React.FC<ChainSelectorProps> = ({ value, onChange }) => (
  <ChainGrid role="radiogroup" aria-label="Tournament chain">
    {CHAIN_ORDER.map((chain) => {
      const config = CHAIN_STAKE_CONFIG[chain];
      const selected = chain === value;
      const Logo = GLYPH_BY_CHAIN[chain];
      return (
        <ChainTile
          key={chain}
          type="button"
          role="radio"
          aria-checked={selected}
          aria-label={`${config.displayName} · ${config.ticker}`}
          selected={selected}
          onClick={() => onChange(chain)}
        >
          <Glyph aria-hidden="true">
            <Logo />
          </Glyph>
          <ChainLabel>
            <ChainName>{config.displayName}</ChainName>
            <ChainSub selected={selected}>{config.ticker} native</ChainSub>
          </ChainLabel>
          <Check
            visible={selected}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.6}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <polyline points="5 12 10 17 19 7" />
          </Check>
        </ChainTile>
      );
    })}
  </ChainGrid>
);

export default ChainSelector;
